export default "__VITE_ASSET__DF9Ssezh__"